import { ICartLicense } from '../../tn.common';
import { cartLicenseIsRenewal } from './license-has-renewal';
import { cartLicenseIsUpgrade } from './license-has-upgrade';

export function isUpgradeOrRenewCartLicense(license: ICartLicense): boolean {
    return Object.keys(license.fontRights).some((key) => {
        return (
            cartLicenseIsUpgrade(license, key) ||
            cartLicenseIsRenewal(license, key)
        );
    });
}

export function hasUpgradeOrRenewCartLicenses(
    licenses: ICartLicense[]
): boolean {
    return licenses.some((license) => isUpgradeOrRenewCartLicense(license));
}
